/**
 * HRSettingsService
 * Admin-only configuration for HR + PaySpace integration.
 * Route: api/HRSettings
 */
import { BaseService } from '../base/BaseService';
export class HRSettingsService extends BaseService {
    constructor(http, config) {
        const internalConfig = {
            servicePath: config?.servicePath ?? HRSettingsService.DEFAULT_SERVICE_PATH,
            basePath: HRSettingsService.BASE_PATH,
            endpoints: config?.endpoints,
        };
        super(http, internalConfig);
    }
    /**
     * GET api/HRSettings — returns settings with the PaySpace client_secret masked.
     */
    async get() {
        const response = await this.getRaw();
        if (!response.data)
            throw new Error('Failed to retrieve HR settings');
        return response.data;
    }
    getRaw() {
        return this.http.get(this.buildUrl());
    }
    /**
     * PUT api/HRSettings — when newClientSecret is provided, replaces the
     * encrypted value at rest; otherwise the existing secret is preserved.
     */
    async update(request) {
        const response = await this.updateRaw(request);
        if (!response.data)
            throw new Error('Failed to update HR settings');
        return response.data;
    }
    updateRaw(request) {
        return this.http.put(this.buildUrl(), request);
    }
    /**
     * POST api/HRSettings/test-connection — verifies the configured PaySpace
     * credentials by acquiring a token and pulling one employee.
     */
    async testConnection() {
        const response = await this.testConnectionRaw();
        if (!response.data)
            throw new Error('Connection test failed');
        return response.data;
    }
    testConnectionRaw() {
        const endpoint = this.getEndpoint('test-connection', 'test-connection');
        return this.http.post(this.buildUrl(endpoint), {});
    }
}
HRSettingsService.DEFAULT_SERVICE_PATH = 'hr';
HRSettingsService.BASE_PATH = 'api/HRSettings';
//# sourceMappingURL=HRSettingsService.js.map